import React from 'react';

import visitLogo from '../../images/visitlogo.svg';
import optionIcons from '../../images/pristyn-care/options.png';
import backIcon from '../../images/common/cross-purple.svg';
import { useHistory } from 'react-router-dom';

const VisitHeader = (props) => {
  const history = useHistory();
  const closeView = () => {
    if (typeof window.Android !== 'undefined') {
      return window.Android.closeView();
    } else if (window.ReactNativeWebView) {
      window.ReactNativeWebView.postMessage(
        JSON.stringify({
          method: 'closeView',
        })
      );
    } else {
      history.goBack();
    }
  };

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        padding: '25px',
        paddingTop: '40px',
        alignItems: 'center',
        boxShadow: '0px -1px 20px rgba(0, 0, 0, 0.1)',
        borderBottom: '1px solid #F0F3F6',
      }}
    >
      <div>
        <img
          src={visitLogo}
          style={{ width: '78px', height: '32.27px' }}
          alt="visit Logo"
        />
      </div>
      {props.showMenu && (
        <div>
          <img
            src={optionIcons}
            style={{ width: '28px', height: '22px' }}
            alt="visit Logo"
          />
        </div>
      )}
      {props.showBack && (
        <div>
          <img
            src={backIcon}
            style={{ width: '18px', height: '18px', cursor: 'pointer' }}
            alt="backIcon Icon"
            onClick={closeView}
          />
        </div>
      )}
    </div>
  );
};

export default VisitHeader;
